var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 3a.75.75 0 0 1 .75.75v.75h7.5v-.75a.75.75 0 0 1 1.5 0v.75H18a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7.5a3 3 0 0 1 3-3h.75v-.75A.75.75 0 0 1 7.5 3Zm8.25 3v.75a.75.75 0 0 0 1.5 0V6H18a1.5 1.5 0 0 1 1.5 1.5V9h-15V7.5A1.5 1.5 0 0 1 6 6h.75v.75a.75.75 0 0 0 1.5 0V6h7.5ZM4.5 10.5V18A1.5 1.5 0 0 0 6 19.5h12a1.5 1.5 0 0 0 1.5-1.5v-7.5h-15Z"
  })));
};

export default SvgCalendar;